import factoryLogger from '../../logger/index.js'
import UserEntityFactory from '../Entities/factory.js'
import {UserErrorsFactory} from '../Errors/factory.js'
import UserMappersFactory from '../Mappers/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import {UserRequestsFactory} from '../Requests/factory.js'
import UserServicesFactory from '../Services/factory.js'
import UserValueObjectsFactory from '../ValueObjects/factory.js'
import {AdShareByEmailUserUseCase} from './AdShareByEmailUserUseCase.js'
import {CheckGigyaUserExistsUserUseCase} from './CheckGigyaUserExistsUserUseCase.js'
import {CheckPhoneVerificationStatusUserUseCase} from './CheckPhoneVerificationStatusUserUseCase.js'
import {GetConsentsUserUseCase} from './GetConsentsUserUseCase.js'
import GetCurrentUserUseCase from './GetCurrentUserUseCase.js'
import {GetPhoneVerificationCodeUserUseCase} from './GetPhoneVerificationCodeUserUseCase.js'
import GetSubscriptionsUserUseCase from './GetSubscriptionsUserUseCase.js'
import GetUserByIdUserUseCase from './GetUserByIdUserUseCase.js'
import GetUserTakeoutLinkUseCase from './GetUserTakeoutLinkUseCase.js'
import GetUserTakeoutListUseCase from './GetUserTakeoutListUseCase.js'
import {SaveLeadHitUserUseCase} from './SaveLeadHitUserUseCase.js'
import SendEmailToVerifyUserUseCase from './SendEmailToVerifyUserUseCase.js'
import {UpdateConsentsUserUseCase} from './UpdateConsentsUserUseCase.js'
import {UpdateDataUserUseCase} from './UpdateDataUserUseCase.js'
import {UpdatePasswordUserUseCase} from './UpdatePasswordUserUseCase.js'
import UpdateSubscriptionsUserUseCase from './UpdateSubscriptionsUserUseCase.js'
import {ValidatePhoneVerificationCodeUserUseCase} from './ValidatePhoneVerificationCodeUserUseCase.js'

export default class UserUseCasesFactory {
  static getConsentsUserUseCase = ({config}) =>
    new GetConsentsUserUseCase({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      httpUserRepository: UserRepositoriesFactory.httpUserRepository({config}),
      sessionStorageUserRepository: UserRepositoriesFactory.sessionStorageUserRepository({config})
    })

  static getCurrentUserUseCase = ({config}) =>
    new GetCurrentUserUseCase({
      service: UserServicesFactory.getCurrentUserService({config}),
      log: factoryLogger({prefix: 'GetCurrentUserUseCase'})
    })

  static getPhoneVerificationCodeUserUseCase = ({config}) =>
    new GetPhoneVerificationCodeUserUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getPhoneVerificationCodeUserService: UserServicesFactory.getPhoneVerificationCodeUserService({config}),
      userEntityFactory: UserEntityFactory.userEntity,
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError
    })

  static getUserTakeoutListUseCase = ({config}) =>
    new GetUserTakeoutListUseCase({
      service: UserServicesFactory.getUserTakeoutListService({config}),
      log: factoryLogger({prefix: 'GetUserTakeoutListUseCase'})
    })

  static getUserTakeoutLinkUseCase = ({config}) =>
    new GetUserTakeoutLinkUseCase({
      service: UserServicesFactory.getUserTakeoutLinkService({config}),
      log: factoryLogger({prefix: 'GetUserTakeoutLinkUseCase'})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   */
  static saveLeadHitUserUseCase = ({config}) =>
    new SaveLeadHitUserUseCase({
      config,
      saveLeadHitUserService: UserServicesFactory.saveLeadHitUserService({
        config
      }),
      leadHitUserVOFactory: UserValueObjectsFactory.leadHitUserValueObject
    })

  static adShareByEmailUserUseCase = ({config}) =>
    new AdShareByEmailUserUseCase({
      config,
      saveAdShareByEmailHitUserService: UserServicesFactory.saveAdShareByEmailHitUserService({
        config
      }),
      adShareByEmailUserService: UserServicesFactory.adShareByEmailUserService({
        config
      })
    })

  static checkGigyaUserExistsUserUseCase = ({config}) =>
    new CheckGigyaUserExistsUserUseCase({
      config,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static checkPhoneVerificationStatusUserUseCase = ({config}) =>
    new CheckPhoneVerificationStatusUserUseCase({
      checkPhoneVerificationStatusUserService: UserServicesFactory.checkPhoneVerificationStatusUserService({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      userEntityFactory: UserEntityFactory.userEntity,
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError
    })

  static getSubscriptionsUserUseCase = ({config}) =>
    new GetSubscriptionsUserUseCase({
      config,
      subscriptionsParamsRequestFactory: UserRequestsFactory.subscriptionsParamsRequest,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static getUserByIdUserUseCase = ({config}) =>
    new GetUserByIdUserUseCase({
      getUserByIdUserService: UserServicesFactory.getUserByIdUserService({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError
    })

  static sendEmailToVerifyUserUseCase = ({config}) =>
    new SendEmailToVerifyUserUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static updateConsentsUserUseCase = ({config}) =>
    new UpdateConsentsUserUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      httpUserRepository: UserRepositoriesFactory.httpUserRepository({config}),
      sessionStorageUserRepository: UserRepositoriesFactory.sessionStorageUserRepository({config})
    })

  static updateDataUserUseCase = ({config}) =>
    new UpdateDataUserUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      updateDataUserRequestFactory: UserRequestsFactory.updateDataUserRequest,
      updateCurrentUserService: UserServicesFactory.updateCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static updatePasswordUserUseCase = ({config}) =>
    new UpdatePasswordUserUseCase({
      cookieUserRepository: UserRepositoriesFactory.cookieUserRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      updatePasswordUserRequestFactory: UserRequestsFactory.updatePasswordUserRequest,
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static updateSubscriptionsUserUseCase = ({config}) =>
    new UpdateSubscriptionsUserUseCase({
      config,
      subscriptionsParamsRequestFactory: UserRequestsFactory.subscriptionsParamsRequest,
      fromSubscriptionsParamRequestToApiBodyMapper: UserMappersFactory.fromSubscriptionsParamRequestToApiBodyMapper({
        config
      }),
      userRepository: UserRepositoriesFactory.httpUserRepository({config})
    })

  static validatePhoneVerificationCodeUserUseCase = ({config}) =>
    new ValidatePhoneVerificationCodeUserUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError,
      validatePhoneVerificationCodeUserRequestFactory: UserRequestsFactory.validatePhoneVerificationCodeUserRequest,
      validatePhoneVerificationCodeUserService: UserServicesFactory.validatePhoneVerificationCodeUserService({config})
    })
}
